import { FornecedorDropDown } from "../../../../common/domain/models/fornecedor_dropdown";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { ProdutoServicoDropDown } from "../../../../common/domain/models/produto_servico_dropdown";
import { FornecedorSimplificadoForm } from "../../../../common/presentation/schemas/FornecedorSimplificado";
import { AlteracaoRequisicaoProdutoServico } from "../../domain/models/alteracao_requisicao_produto_servico";
import { FuncionarioAprovador } from "../../domain/models/funcionario_aprovador";
import { AvaliacaoOrdemCompra } from "../../domain/models/avaliacao_ordem_compra";
import { ColetaPreco } from "../../domain/models/coleta_preco";
import { ColetaPrecoFornecedor } from "../../domain/models/coleta_preco_fornecedor";
import { ColetaPrecoLista } from "../../domain/models/coleta_preco_lista";
import { ColetaProdutoServicoLista } from "../../domain/models/coleta_produto_servico_lista";
import { ConfigurarPagamentoColeta } from "../../domain/models/configurar_pagamento_coleta";
import { CriterioAvaliacaoFornecedor } from "../../domain/models/criterio_avaliacao_fornecedor";
import { DashboardCompras } from "../../domain/models/dashboard_compras";
import { ProdutoServicoEntregue } from "../../domain/models/entrega_ordem_compra_produto_servico";
import { FornecedorLista } from "../../domain/models/fornecedor";
import { FornecedorAtividadeDropDown } from "../../domain/models/fornecedor_atividade_dropdown";
import { FornecedorAvaliacao } from "../../domain/models/fornecedor_avaliacao";
import { FornecedorAvaliacaoItem } from "../../domain/models/fornecedor_avaliacao_item";
import { FornecedorBanco } from "../../domain/models/fornecedor_banco";
import { FornecedorDetalhe } from "../../domain/models/fornecedor_detalhe";
import { FornecedorDocumento } from "../../domain/models/fornecedor_documento";
import { FornecedorFamiliaDropDown } from "../../domain/models/fornecedor_familia_dropdown";
import { FornecedorQualificacao } from "../../domain/models/fornecedor_qualificacao";
import { InformacaoFaturamentoDetalhes } from "../../domain/models/informacao_faturamento_detalhes";
import { OrdemCompraBancoDropDown } from "../../domain/models/ordem_compra_banco_dropdown";
import { OrdemCompraCanceladoStatus } from "../../domain/models/ordem_compra_cancelado_status";
import { OrdemCompraCentroCustoDropDown } from "../../domain/models/ordem_compra_centro_custo_dropdown";
import { OrdemCompraDetalhes } from "../../domain/models/ordem_compra_detalhes";
import { OrdemCompraInformacaoFaturamentoDropDown } from "../../domain/models/ordem_compra_informacao_faturamento";
import { OrdemCompraLista } from "../../domain/models/ordem_compra_lista";
import { OrdemCompraPreco } from "../../domain/models/ordem_compra_preco";
import { OrdemCompraTotalValor } from "../../domain/models/ordem_compra_total_valor";
import { ProdutoServicoParaEntrega } from "../../domain/models/produto_servicos_para_entrega";
import { RequisicaoCompra } from "../../domain/models/requisicao_compra";
import { RequisicaoCompraLista } from "../../domain/models/requisicao_compra_lista";
import { RequisicaoProdutoServicoDropDown } from "../../domain/models/requisicao_produto_servico_dropdown";
import { RequisicaoProdutoServicoLista } from "../../domain/models/requisicao_produto_servico_lista";
import { ServicoProdutoLista } from "../../domain/models/servico_produto_lista";
import { IComprasRepository } from "../../domain/repositories/compras_repositories";
import { ProdutoServicoForm } from "../../presentation/schemas/ProdutosServicos_lista/ProdutoServico";
import { IComprasService } from "../services/compras_service";
import { FuncionarioAprovacaoDropDown } from "../../domain/models/funcionario_aprovacao";

/**
 * ComprasRepository
 */

export class ComprasRepository implements IComprasRepository {
	constructor(
		private readonly service: IComprasService,
	) { }

	/**
	 * DROPDOWN
	 */

	//#region DROPDOWN

	async getFornecedoresFamiliasDropDown(): Promise<FornecedorFamiliaDropDown[]> {
		const response = await this.service.getFornecedoresFamiliasDropDown({
		});
		return response.itens;
	}

	async getFornecedoresAtividadesDropDown(): Promise<FornecedorAtividadeDropDown[]> {
		const response = await this.service.getFornecedoresAtividadesDropDown({
		});
		return response.itens;
	}

	async getFornecedorByFamiliaDropDown(
		familia: string,
	): Promise<FornecedorDropDown[]> {
		const response = await this.service.getFornecedorByFamiliaDropDown({
			familia,
		});
		return response.itens;
	}

	async getProdutosServicosByIdRequisicaoCompraDropDown(
		idRequisicaoCompra: number,
	): Promise<RequisicaoProdutoServicoDropDown[]> {
		const response = await this.service.getProdutosServicosByIdRequisicaoCompraDropDown({
			idRequisicaoCompra,
		});
		return response.itens;
	}

	async getFornecedoresDetalheDropDown(
	): Promise<FornecedorDropDown[]> {
		const response = await this.service.getFornecedoresDetalheDropDown({
		});
		return response.itens;
	}

	async getOrdemCompraInformacaoFaturamentoDropDown(
		idOrdemCompra: number,
	): Promise<OrdemCompraInformacaoFaturamentoDropDown[]> {
		const response = await this.service
			.getOrdemCompraInformacaoFaturamentoDropDown({ idOrdemCompra });
		return response.itens;
	}

	async getOrdemCompraCentroCustoDropDown(
		idOrdemCompra: number | undefined,
	): Promise<OrdemCompraCentroCustoDropDown[]> {
		const response = await this.service
			.getOrdemCompraCentroCustoDropDown({ idOrdemCompra });
		return response.itens;
	}

	async getOrdemCompraBancoDropDown(
		idOrdemCompra: number,
	): Promise<OrdemCompraBancoDropDown[]> {
		const response = await this.service
			.getOrdemCompraBancoDropDown({ idOrdemCompra });
		return response.itens;
	}

	async getProdutoServicoByIdOrdemCompraDropDown(
		idOrdemCompra: number,
	): Promise<ProdutoServicoDropDown[]> {
		const response = await this.service
			.getProdutoServicoByIdOrdemCompraDropDown({ idOrdemCompra });
		return response.itens;
	}

	//#endregion DROPDOWN

	//#region PRODUTOS SERVICOS
	async createProdutoServico(form: ProdutoServicoForm): Promise<number> {
		const result = await this.service.createProdutoServico({
			descricao: form.descricao,
			ativo: form.ativo,
			tipo: form.tipo === 1 ? 'P' : 'S',
			unidade: form.unidade ?? undefined,
			norma: form.norma ?? undefined
		})

		return result.idProdutoServico;

	}

	//#endregion



	//#region FORNECEDOR

	async createFornecedorSimplificado(form: FornecedorSimplificadoForm): Promise<number> {
		const result = await this.service.createFornecedorSimplificado({
			nomeFantasia: form.nomeFantasia,
			ativo: form.ativo,
			avaliar: form.avaliar,
			fornProduto: form.fornProduto,
			fornServico: form.fornServico,
			idCentroCusto: form.idCentroCusto ?? undefined,
			cpf: form.cpf ?? undefined,
			familia: form.cpf ?? undefined,
			observacao: form.observacao ?? undefined,
			cnpj: form.cnpj ?? undefined
		})

		return result.idFornecedor;

	}

	async getAllFornecedor(
		razaoSocial: string,
		cnpj: string,
		cpf: string,
		nomeFantasia: string,
		centroCustos: number[] | null,
		familias: string[] | null,
		atividades: string[] | null,
		documento: number,
		tipoFornecedor: number,
		status: number,
		avaliacaoCentroCusto: number[] | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<FornecedorLista>> {
		return await this.service.getAllFornecedor({
			razaoSocial,
			cnpj,
			cpf,
			nomeFantasia,
			centroCustos,
			familias,
			atividades,
			documento,
			tipoFornecedor,
			status,
			avaliacaoCentroCusto,
			page,
			rowsPerPage,
		});

	}

	async deleteFornecedor(
		idFornecedor: number,
	): Promise<void> {
		await this.service.deleteFornecedor({
			idFornecedor,
		});
	}

	async getAllCriterioAvaliacaoFornecedor(
	): Promise<CriterioAvaliacaoFornecedor[]> {
		const response = await this.service.getAllCriterioAvaliacaoFornecedor({});
		return response.itens;
	}

	async createAvaliacaoFornecedor(
		fornecedores: number[],
		avaliadoPor: number,
		data: Date,
		centroCusto: number,
		nroNotaFiscal: string,
		observacao: string,
		criteriosAvaliacaoFornecedor: {
			idCriterioAvaliacaoFornecedor: number;
			nota: number;
		}[],
	): Promise<void> {
		await this.service.createAvaliacaoFornecedor({
			fornecedores,
			avaliadoPor,
			data,
			centroCusto,
			nroNotaFiscal,
			observacao,
			criteriosAvaliacaoFornecedor,
		});
	}

	async getFornecedorById(
		idFornecedor: number,
	): Promise<FornecedorDetalhe | null> {
		const response = await this.service.getFornecedorById({ idFornecedor });
		return response.item;
	}

	async getDocumentosByIdFornecedor(
		idFornecedor: number,
	): Promise<FornecedorDocumento[]> {
		const response = await this.service.getDocumentosByIdFornecedor({
			idFornecedor,
		});
		return response.itens;
	}

	async getAvaliacoesByIdFornecedor(
		idFornecedor: number,
	): Promise<FornecedorAvaliacao[]> {
		const response = await this.service.getAvaliacoesByIdFornecedor({
			idFornecedor,
		});
		return response.itens;
	}

	async getBancosByIdFornecedor(
		idFornecedor: number,
	): Promise<FornecedorBanco[]> {
		const response = await this.service.getBancosByIdFornecedor({
			idFornecedor,
		});
		return response.itens;
	}

	async getFornecedorDocumentoFileContent(
		idFornecedor: number,
		idFornecedorArquivo: number,
	): Promise<Blob> {
		const response = await this.service.getFornecedorDocumentoFileContent({
			idFornecedor,
			idFornecedorArquivo,
		});
		return response;
	}

	async toggleFornecedorDesqualificado(
		idFornecedor: number
	): Promise<void> {
		await this.service.toggleFornecedorDesqualificado({
			idFornecedor,
		});
	}

	async getAllFornecedorQualificacao(
		idFornecedor: number | null,
	): Promise<FornecedorQualificacao[]> {
		const response = await this.service.getAllFornecedorQualificacao({
			idFornecedor,
		});
		return response.itens;
	}

	async getFornecedorAvaliacaoItensById(
		idAvaliacaoFornecedor: number,
	): Promise<FornecedorAvaliacaoItem[]> {
		const response = await this.service.getFornecedorAvaliacaoItensById({
			idAvaliacaoFornecedor
		});
		return response.itens;
	}

	async createFornecedorBanco(
		idFornecedor: number,
		tipoConta: number,
		banco: string,
		agencia: string,
		conta: string,
		contaDigito: string,
		operacao: string,
		favorecido: string,
		cpfCnpj: string,
		pix: string,
	): Promise<void> {
		await this.service.createFornecedorBanco({
			idFornecedor,
			tipoConta,
			banco,
			agencia,
			conta,
			contaDigito,
			operacao,
			favorecido,
			cpfCnpj,
			pix,
		});
	}

	async updateFornecedorBanco(
		idFornecedor: number,
		idBanco: number,
		tipoConta: number,
		banco: string,
		agencia: string,
		conta: string,
		contaDigito: string,
		operacao: string,
		favorecido: string,
		cpfCnpj: string,
		pix: string,
	): Promise<void> {
		await this.service.updateFornecedorBanco({
			idFornecedor,
			idBanco,
			tipoConta,
			banco,
			agencia,
			conta,
			contaDigito,
			operacao,
			favorecido,
			cpfCnpj,
			pix,
		});
	}

	async deleteFornecedorBanco(
		idFornecedor: number,
		idBanco: number,
	): Promise<void> {
		await this.service.deleteFornecedorBanco({
			idFornecedor,
			idBanco,
		});
	}

	async updateFornecedorAvaliacao(
		idFornecedor: number,
		idAvaliacaoFornecedor: number,
		avaliadoPor: number,
		data: Date,
		observacao: string,
		items: {
			idItemAvaliacaoFornecedor: number;
			nota: number | null;
		}[],
	): Promise<void> {
		await this.service.updateFornecedorAvaliacao({
			idFornecedor,
			idAvaliacaoFornecedor,
			avaliadoPor,
			data,
			observacao,
			items,
		});
	}

	async deleteFornecedorAvaliacao(
		idFornecedor: number,
		idAvaliacaoFornecedor: number,
	): Promise<void> {
		await this.service.deleteFornecedorAvaliacao({
			idFornecedor,
			idAvaliacaoFornecedor,
		});
	}

	async createFornecedorDocumento(
		idFornecedor: number,
		statusArquivo: number,
		nomeDocumento: string,
		dataVencimento: Date | null,
		arquivo: File | null,
	): Promise<void> {
		await this.service.createFornecedorDocumento({
			idFornecedor,
			statusArquivo,
			nomeDocumento,
			dataVencimento,
			arquivo,
		});
	}

	async updateFornecedorDocumento(
		idFornecedor: number,
		idFornecedorArquivo: number,
		statusArquivo: number,
		nomeDocumento: string,
		dataVencimento: Date | null,
		arquivo: File | null,
		limparArquivo: boolean,
	): Promise<void> {
		await this.service.updateFornecedorDocumento({
			idFornecedor,
			idFornecedorArquivo,
			statusArquivo,
			nomeDocumento,
			dataVencimento,
			arquivo,
			limparArquivo,
		});
	}

	async deleteFornecedorDocumento(
		idFornecedor: number,
		idFornecedorArquivo: number
	): Promise<void> {
		await this.service.deleteFornecedorDocumento({
			idFornecedor,
			idFornecedorArquivo,
		});
	}

	async createFornecedor(
		idCentroCusto: number | null,
		dataCadastro: Date | null,
		razaoSocial: string,
		nomeFantasia: string,
		cnpj: string,
		cpf: string,
		inscricaoEstadual: string,
		inscricaoMunicipal: string,
		atividade: string,
		obsFornecedor: string,
		contato: string,
		telefoneFixo: string,
		telefoneCelular: string,
		email: string,
		contato1: string,
		email1: string,
		descQualificacoes: string,
		fornProduto: boolean,
		fornServico: boolean,
		familia: string,
		ativo: boolean,
		avaliar: boolean,
		avaliacaoFinanceira: string,
		dataValidade: Date | null,
		rua: string,
		numero: string,
		apartamento: string,
		cep: string,
		uf: string,
		cidade: string,
		bairro: string,
		pais: string,
		qualificacoes: {
			idQualificacao: number;
			qualificado: boolean;
			observacao: string;
		}[],
	): Promise<number> {
		const response = await this.service.createFornecedor({
			idCentroCusto,
			dataCadastro,
			razaoSocial,
			nomeFantasia,
			cnpj,
			cpf,
			inscricaoEstadual,
			inscricaoMunicipal,
			atividade,
			obsFornecedor,
			contato,
			telefoneFixo,
			telefoneCelular,
			email,
			contato1,
			email1,
			descQualificacoes,
			fornProduto,
			fornServico,
			familia,
			ativo,
			avaliar,
			avaliacaoFinanceira,
			dataValidade,
			rua,
			numero,
			apartamento,
			cep,
			uf,
			cidade,
			bairro,
			pais,
			qualificacoes,
		});

		return response.idFornecedor;
	}

	async updateFornecedor(
		idFornecedor: number,
		idCentroCusto: number | null,
		dataCadastro: Date | null,
		razaoSocial: string,
		nomeFantasia: string,
		cnpj: string,
		cpf: string,
		inscricaoEstadual: string,
		inscricaoMunicipal: string,
		atividade: string,
		obsFornecedor: string,
		contato: string,
		telefoneFixo: string,
		telefoneCelular: string,
		email: string,
		contato1: string,
		email1: string,
		descQualificacoes: string,
		fornProduto: boolean,
		fornServico: boolean,
		familia: string,
		ativo: boolean,
		avaliar: boolean,
		avaliacaoFinanceira: string,
		dataValidade: Date | null,
		rua: string,
		numero: string,
		apartamento: string,
		cep: string,
		uf: string,
		cidade: string,
		bairro: string,
		pais: string,
		qualificacoes: {
			idQualificacao: number;
			qualificado: boolean;
			observacao: string;
		}[],
	): Promise<void> {
		await this.service.updateFornecedor({
			idFornecedor,
			idCentroCusto,
			dataCadastro,
			razaoSocial,
			nomeFantasia,
			cnpj,
			cpf,
			inscricaoEstadual,
			inscricaoMunicipal,
			atividade,
			obsFornecedor,
			contato,
			telefoneFixo,
			telefoneCelular,
			email,
			contato1,
			email1,
			descQualificacoes,
			fornProduto,
			fornServico,
			familia,
			ativo,
			avaliar,
			avaliacaoFinanceira,
			dataValidade,
			rua,
			numero,
			apartamento,
			cep,
			uf,
			cidade,
			bairro,
			pais,
			qualificacoes,
		});
	}

	//#endregion

	// ──────────────── SERVICO/PRODUTO ────────────────
	//#region SERVICO/PRODUTO

	async getAllServicoProduto(
		field: number | null,
		fieldValue: string | null,
		tipo: number | null,
		status: number | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<ServicoProdutoLista>> {
		return await this.service.getAllServicoProduto({
			field,
			fieldValue,
			tipo,
			status,
			page,
			rowsPerPage,
		});
	}

	async createServicoProduto(
		ativo: boolean,
		produtoServico: string,
		tipo: number,
		unidade: string | null,
		norma: string | null,
	): Promise<number> {
		const response = await this.service.createServicoProduto({
			ativo,
			produtoServico,
			tipo,
			unidade,
			norma,
		});

		return response.idProdutoServico;
	}

	async updateServicoProduto(
		idProdutoServico: number,
		ativo: boolean,
		produtoServico: string,
		tipo: number,
		unidade: string | null,
		norma: string | null,
	): Promise<void> {
		await this.service.updateServicoProduto({
			idProdutoServico,
			ativo,
			produtoServico,
			tipo,
			unidade,
			norma,
		});
	}

	async deleteServicoProduto(
		idProdutoServico: number,
	): Promise<void> {
		await this.service.deleteServicoProduto({
			idProdutoServico,
		});
	}

	async inativarServicoProdutoLoteServicoProduto(
		idsProdutoServico: number[],
	): Promise<void> {
		await this.service.inativarServicoProdutoLoteServicoProduto({
			idsProdutoServico,
		});
	}

	async getAllRequisicaoCompra(
		nroRequisicao: number | null,
		dataRequisicaoStart: Date | null,
		dataRequisicaoEnd: Date | null,
		centroCustos: number[] | null,
		solicitantes: number[] | null,
		status: number | null,
		produtoServicos: number[] | null,
		dataPrevistaStart: Date | null,
		dataPrevistaEnd: Date | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<RequisicaoCompraLista>> {
		return await this.service.getAllRequisicaoCompra({
			nroRequisicao,
			dataRequisicaoStart,
			dataRequisicaoEnd,
			centroCustos,
			solicitantes,
			status,
			produtoServicos,
			dataPrevistaStart,
			dataPrevistaEnd,
			page,
			rowsPerPage,
		});
	}

	async getRequisicaoCompraById(
		idRequisicaoProdutoServico: number,
	): Promise<RequisicaoCompra | null> {
		const response = await this.service.getRequisicaoCompraById({
			idRequisicaoProdutoServico,
		});
		return response.item;
	}

	async deleteRequisicaoCompra(
		idTela: number,
		idRequisicaoCompra: number,
	): Promise<void> {
		await this.service.deleteRequisicaoCompra({
			idTela,
			idRequisicaoCompra,
		});
	}

	async sendEmailRequisicaoCompra(
		idRequisicaoCompra: number,
		subject: string,
		emails: string[],
		body: string,
		attachment: string,
	): Promise<void> {
		await this.service.sendEmailRequisicaoCompra({
			idRequisicaoCompra,
			subject,
			emails,
			body,
			attachment,
		});
	}

	async copyRequisicaoCompra(
		idRequisicaoCompra: number,
	): Promise<void> {
		await this.service.copyRequisicaoCompra({
			idRequisicaoCompra,
		});
	}

	async finalizarLoteRequisicaoCompra(
		idsRequisicaoCompra: number[],
	): Promise<void> {
		await this.service.finalizarLoteRequisicaoCompra({
			idsRequisicaoCompra,
		});
	}

	async createRequisicaoCompra(
		status: number,
		aprovadoPor: number | null,
		dataAprovadoPor: Date | null,
		dataCadastro: Date,
		solicitante: number | null,
		dataRequisicao: Date | null,
		centroCusto: number | null,
		dataPrevistaUtilizacao: Date | null,
		descricao: string | null,
		observacao: string | null,
		arquivo1: File | null,
		arquivo2: File | null,
	): Promise<number> {
		const response = await this.service.createRequisicaoCompra({
			status,
			aprovadoPor,
			dataAprovadoPor,
			dataCadastro,
			solicitante,
			dataRequisicao,
			centroCusto,
			dataPrevistaUtilizacao,
			descricao,
			observacao,
			arquivo1,
			arquivo2,
		});
		return response.idRequisicaoCompra;
	}

	async updateRequisicaoCompra(
		idRequisicaoCompra: number,
		status: number,
		aprovadoPor: number | null,
		dataAprovadoPor: Date | null,
		dataCadastro: Date,
		solicitante: number | null,
		dataRequisicao: Date | null,
		centroCusto: number | null,
		dataPrevistaUtilizacao: Date | null,
		descricao: string | null,
		observacao: string | null,
		arquivo1: File | null,
		limparArquivo1: boolean,
		arquivo2: File | null,
		limparArquivo2: boolean,
	): Promise<void> {
		await this.service.updateRequisicaoCompra({
			idRequisicaoCompra,
			status,
			aprovadoPor,
			dataAprovadoPor,
			dataCadastro,
			solicitante,
			dataRequisicao,
			centroCusto,
			dataPrevistaUtilizacao,
			descricao,
			observacao,
			arquivo1,
			limparArquivo1,
			arquivo2,
			limparArquivo2,
		});
	}

	async getAllRequisicaoProdutoServico(
		idRequisicaoCompra: number,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<RequisicaoProdutoServicoLista>> {
		return await this.service.getAllRequisicaoProdutoServico({
			idRequisicaoCompra,
			page,
			rowsPerPage,
		});
	}

	async getAllAlteracaoRequisicaoCompraProdutoServico(
		idRequisicaoCompra: number,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<AlteracaoRequisicaoProdutoServico>> {
		return await this.service.getAllAlteracaoRequisicaoCompraProdutoServico({
			idRequisicaoCompra,
			page,
			rowsPerPage,
		});
	}

	async createRequisicaoCompraProdutoServico(
		idRequisicaoCompra: number,
		idProdutoServico: number,
		idSubconta: number | null,
		quantidade: number
	): Promise<number> {
		const response = await this.service.createRequisicaoCompraProdutoServico({
			idRequisicaoCompra,
			idProdutoServico,
			idSubconta,
			quantidade,
		});
		return response.id;
	}

	async updateRequisicaoCompraProdutoServico(
		idRequisicaoProdutoServico: number,
		idProdutoServico: number,
		idSubconta: number | null,
		quantidade: number
	): Promise<void> {
		await this.service.updateRequisicaoCompraProdutoServico({
			idRequisicaoProdutoServico,
			idProdutoServico,
			idSubconta,
			quantidade,
		});
	}

	async deleteRequisicaoCompraProdutoServico(
		idRequisicaoProdutoServico: number,
	): Promise<void> {
		await this.service.deleteRequisicaoCompraProdutoServico({
			idRequisicaoProdutoServico,
		});
	}

	async getAllColetaPreco(
		dataRequisicaoStart: Date | null,
		dataRequisicaoEnd: Date | null,
		fornecedor: number[] | null,
		requisicao: number[] | null,
		produtoServico: number[] | null,
		centroCusto: number[] | null,
		nroColeta: string | null,
		ordemCompra: number[] | null,
		status: number,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<ColetaPrecoLista>> {
		return await this.service.getAllColetaPreco({
			dataRequisicaoStart,
			dataRequisicaoEnd,
			fornecedor,
			requisicao,
			produtoServico,
			centroCusto,
			nroColeta,
			ordemCompra,
			status,
			page,
			rowsPerPage,
		});
	}

	async getColetaPrecoById(
		idColetaPreco: number
	): Promise<ColetaPreco | null> {
		const response = await this.service.getColetaPrecoById({
			idColetaPreco,
		});
		return response.item;
	}

	async copyColetaPreco(
		idColetaPreco: number
	): Promise<void> {
		await this.service.copyColetaPreco({
			idColetaPreco,
		});
	}

	async deleteColetaPreco(
		idTela: number,
		idColetaPreco: number,
	): Promise<void> {
		await this.service.deleteColetaPreco({
			idTela,
			idColetaPreco,
		});
	}

	async finalizarRequisicaoCompra(
		idRequisicaoCompra: number,
	): Promise<void> {
		await this.service.finalizarRequisicaoCompra({
			idRequisicaoCompra,
		});
	}

	async createColetaPreco(
		status: number,
		dataCadastro: Date,
		idRequisicaoCompra: number,
		dataColeta: Date | null,
		idSubconta: number | null,
		idFuncionarioComprador: number | null,
		idFuncionarioAprovadores: number[] | null,
		arquivo1: File | null,
		arquivo2: File | null,
		arquivo3: File | null,
	): Promise<number> {
		const response = await this.service.createColetaPreco({
			status,
			dataCadastro,
			idRequisicaoCompra,
			dataColeta,
			idSubconta,
			idFuncionarioComprador,
			idFuncionarioAprovadores,
			arquivo1,
			arquivo2,
			arquivo3,
		});
		return response.id;
	}

	async updateColetaPreco(
		idColetaPreco: number,
		status: number,
		dataCadastro: Date,
		idRequisicaoCompra: number,
		dataColeta: Date | null,
		idSubconta: number | null,
		idFuncionarioComprador: number | null,
		idFuncionarioAprovadores: number[] | null,
		arquivo1: File | null,
		limparArquivo1: boolean,
		arquivo2: File | null,
		limparArquivo2: boolean,
		arquivo3: File | null,
		limparArquivo3: boolean,
	): Promise<void> {
		await this.service.updateColetaPreco({
			idColetaPreco,
			status,
			dataCadastro,
			idRequisicaoCompra,
			dataColeta,
			idSubconta,
			idFuncionarioComprador,
			idFuncionarioAprovadores,
			arquivo1,
			limparArquivo1,
			arquivo2,
			limparArquivo2,
			arquivo3,
			limparArquivo3,
		});
	}

	async createColetaPrecoFornecedor(
		idColetaPreco: number,
		idRequisicaoCompra: number,
		idFornecedor: number,
		idsProdutosServicos: number[],
	): Promise<number> {
		const response = await this.service.createColetaPrecoFornecedor({
			idColetaPreco,
			idRequisicaoCompra,
			idFornecedor,
			idsProdutosServicos,
		});
		return response.id;
	}

	async updateColetaPrecoFornecedor(
		idColetaPrecoFornecedor: number,
		imposto: number | null,
		frete: number | null,
		desconto: number | null,
		acrescimo: number | null,
		dataEntrega: Date | null,
		condicoesPagamento: string | null,
		observacoes: string | null,
		coletaProdutosServicos: {
			idColetaProdutoServico: number;
			valorUnitario: number | null;
			quantidadeColeta: number | null;
			observacao: string | null;
		}[],
	): Promise<void> {
		await this.service.updateColetaPrecoFornecedor({
			idColetaPrecoFornecedor,
			imposto,
			frete,
			desconto,
			acrescimo,
			dataEntrega,
			condicoesPagamento,
			observacoes,
			coletaProdutosServicos,
		});
	}

	async copyColetaPrecoFornecedor(
		idColetaPrecoFornecedor: number,
		idFornecedor: number,
	): Promise<void> {
		await this.service.copyColetaPrecoFornecedor({
			idColetaPrecoFornecedor,
			idFornecedor,
		});
	}

	async deleteColetaPrecoFornecedor(
		idColetaPrecoFornecedor: number,
	): Promise<void> {
		await this.service.deleteColetaPrecoFornecedor({
			idColetaPrecoFornecedor,
		});
	}

	async getAllColetaPrecoFornecedor(
		idColetaPreco: number,
	): Promise<ColetaPrecoFornecedor[]> {
		const response = await this.service.getAllColetaPrecoFornecedor({
			idColetaPreco,
		});
		return response.itens;
	}

	async getAllColetaProdutoServico(
		idColetaPrecoFornecedor: number
	): Promise<ColetaProdutoServicoLista[]> {
		const response = await this.service.getAllColetaProdutoServico({
			idColetaPrecoFornecedor,
		});
		return response.itens;
	}

	async aprovarColetaPrecoFornecedor(
		idColetaPrecoFornecedor: number,
		idFuncionarioAprovador: number,
	): Promise<void> {
		await this.service.aprovarColetaPrecoFornecedor({
			idColetaPrecoFornecedor,
			idFuncionarioAprovador,
		});
	}

	async cancelarAprovacaoColetaPrecoFornecedor(
		idColetaPreco: number,
	): Promise<void> {
		await this.service.cancelarAprovacaoColetaPrecoFornecedor({
			idColetaPreco,
		});
	}

	async gerarOrdemCompraColetaPreco(
		idColetaPreco: number,
	): Promise<void> {
		await this.service.gerarOrdemCompraColetaPreco({
			idColetaPreco,
		});
	}

	async configurarPagamentoColetaPreco(
		idColetaPreco: number,
		valorTotal: number,
		titulo: string | null,
		formaPagamento: string | null,
		notaFiscal: string | null,
		pagamentoAvista: boolean,
		dataPagamento: Date | null,
		pagamentoEm: number | null,
		entrada: number | null,
		valorEntrada: number | null,
		dataEntrada: Date | null,
		nroParcelas: number | null,
		dataPrimeiroPagamento: Date | null,
		nroDiasEntreParcelas: number | null,
		informacoesGerais: string | null,
	): Promise<void> {
		await this.service.configurarPagamentoColetaPreco({
			idColetaPreco,
			valorTotal,
			titulo,
			formaPagamento,
			notaFiscal,
			pagamentoAvista,
			dataPagamento,
			pagamentoEm,
			entrada,
			valorEntrada,
			dataEntrada,
			nroParcelas,
			dataPrimeiroPagamento,
			nroDiasEntreParcelas,
			informacoesGerais,
		});
	}

	async getConfigurarPagamentoColetaPreco(
		idColetaPreco: number,
	): Promise<ConfigurarPagamentoColeta | null> {
		const response = await this.service.getConfigurarPagamentoColetaPreco({
			idColetaPreco,
		});
		return response.item;
	}

	async deleteConfigurarPagamentoColetaPreco(
		idColetaPreco: number,
	): Promise<void> {
		await this.service.deleteConfigurarPagamentoColetaPreco({
			idColetaPreco,
		});
	}

	async getAllOrdemCompra(
		telaId: number,
		centroCusto: number[] | null,
		fornecedor: number[] | null,
		coletaPreco: number[] | null,
		ordemCompra: number[] | null,
		produtoServico: number[] | null,
		status: number[] | null,
		statusNF: number,
		nroNotaFiscal: string | null,
		dataOCStart: Date | null,
		dataOCEnd: Date | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<OrdemCompraLista>> {
		return this.service.getAllOrdemCompra({
			telaId,
			centroCusto,
			fornecedor,
			coletaPreco,
			ordemCompra,
			produtoServico,
			status,
			statusNF,
			nroNotaFiscal,
			dataOCStart,
			dataOCEnd,
			page,
			rowsPerPage,
		});
	}

	async getOrdemCompraById(
		telaId: number,
		idOrdemCompra: number,
	): Promise<OrdemCompraDetalhes | null> {
		const response = await this.service.getOrdemCompraById({
			idOrdemCompra,
			telaId,
		});
		return response.item;
	}

	async sendEmailOrdemCompra(
		idOrdemCompra: number,
		subject: string,
		emails: string[],
		body: string,
		attachment: string,
	): Promise<void> {
		await this.service.sendEmailOrdemCompra({
			idOrdemCompra,
			subject,
			emails,
			body,
			attachment,
		});
	}

	async getInformacaoFaturamentoById(
		idInformacaoFaturamento: number
	): Promise<InformacaoFaturamentoDetalhes | null> {
		const response = await this.service.getInformacaoFaturamentoById({
			idInformacaoFaturamento
		});
		return response.item;
	}

	async updateOrdemCompra(
		idOrdemCompra: number,
		idInformacaoFaturamento: number | null,
		idCentroCustoEndereco: number | null,
		dataRef: Date | null,
		entrega: number,
		responsavelDescarga: number,
		informacaoGeral: string | null,
		observacao: string | null,
		rua: string | null,
		numero: string | null,
		complemento: string | null,
		cep: string | null,
		estado: string | null,
		cidade: string | null,
		bairro: string | null,
		pais: string | null,
		nomeBanco: string | null,
		tipoConta: number | null,
		nrConta: string | null,
		digito: string | null,
		agencia: string | null,
		operacao: string | null,
		favorecido: string | null,
		cpfCnpj: string | null,
		pix: string | null,
	): Promise<void> {
		await this.service.updateOrdemCompra({
			idOrdemCompra,
			idInformacaoFaturamento,
			idCentroCustoEndereco,
			dataRef,
			entrega,
			responsavelDescarga,
			informacaoGeral,
			observacao,
			rua,
			numero,
			complemento,
			cep,
			estado,
			cidade,
			bairro,
			pais,
			nomeBanco,
			tipoConta,
			nrConta,
			digito,
			agencia,
			operacao,
			favorecido,
			cpfCnpj,
			pix,
		});
	}

	async getOrdemCompraAvaliacaoFornecedor(
		idOrdemCompra: number
	): Promise<AvaliacaoOrdemCompra | null> {
		const response = await this.service.getOrdemCompraAvaliacaoFornecedor({
			idOrdemCompra,
		});
		return response.item;
	}

	async updateAvaliacaoOrdemCompra(
		idOrdemCompra: number,
		statusEntrega: number,
		statusNfEntrega: number | null,
		data: Date | null,
		avaliadoPor: number | null,
		nroNotaFiscal: string | null,
		observacao: string | null,
		arquivo: File | null,
		limparArquivo: boolean,
		arquivoBoleto: File | null,
		limparArquivoBoleto: boolean,
		criterioItems: {
			idCriterioAvaliacaoFornecedor: number;
			idItemAvaliacaoFornecedor: number | null;
			nota: number | null;
		}[],
	): Promise<void> {
		await this.service.updateAvaliacaoOrdemCompra({
			idOrdemCompra,
			statusEntrega,
			statusNfEntrega,
			data,
			avaliadoPor,
			nroNotaFiscal,
			observacao,
			arquivo,
			limparArquivo,
			arquivoBoleto,
			limparArquivoBoleto,
			criterioItems,
		});
	}

	async createAvaliacaoOrdemCompraColeta(
		idOrdemCompra: number,
		nroNotaFiscal: string | null,
		dataEntrega: Date,
		arquivo: File | null,
		produtosServicos: {
			idProdutoServico: number;
			quantidadeRecebida: number | null;
		}[],
		registrarEntradaEstoque: boolean,
	): Promise<void> {
		await this.service.createAvaliacaoOrdemCompraColeta({
			idOrdemCompra,
			nroNotaFiscal,
			dataEntrega,
			arquivo,
			produtosServicos,
			registrarEntradaEstoque,
		});
	}

	async createEntradasEstoqueOrdemCompra(
		idOrdemCompra: number,
		idCentroCusto: number,
		data: Date | null,
		idsProdutosServicosEntregues: number[],
	): Promise<void> {
		await this.service.createEntradasEstoqueOrdemCompra({
			idOrdemCompra,
			idCentroCusto,
			data,
			idsProdutosServicosEntregues,
		});
	}

	async cancelarOrdemCompra(
		idOrdemCompra: number,
		motivo: string | null,
	): Promise<void> {
		await this.service.cancelarOrdemCompra({
			idOrdemCompra,
			motivo,
		});
	}

	async getOrdemCompraCanceladoStatus(
		idOrdemCompra: number,
	): Promise<OrdemCompraCanceladoStatus | null> {
		const response = await this.service.getOrdemCompraCanceladoStatus({
			idOrdemCompra,
		});
		return response.item;
	}

	async getAllOrdemCompraPrecos(
		centroCustos: number[] | null,
		titulo: string | null,
		fornecedores: number[] | null,
		dataOrdemCompraDe: Date | null,
		dataOrdemCompraAte: Date | null,
		ordemCompras: number[] | null,
		produtosServicos: number[] | null,
		dataPagoDe: Date | null,
		dataPagoAte: Date | null,
		subcontas: number[] | null,
		statusOC: number[] | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<OrdemCompraPreco>> {
		return await this.service.getAllOrdemCompraPrecos({
			centroCustos,
			titulo,
			fornecedores,
			dataOrdemCompraDe,
			dataOrdemCompraAte,
			ordemCompras,
			produtosServicos,
			dataPagoDe,
			dataPagoAte,
			subcontas,
			statusOC,
			page,
			rowsPerPage,
		});
	}

	async getOrdemCompraTotalValores(
		centroCustos: number[] | null,
		titulo: string | null,
		fornecedores: number[] | null,
		dataOrdemCompraDe: Date | null,
		dataOrdemCompraAte: Date | null,
		ordemCompras: number[] | null,
		produtosServicos: number[] | null,
		dataPagoDe: Date | null,
		dataPagoAte: Date | null,
		subcontas: number[] | null,
		statusOC: number[] | null,
	): Promise<OrdemCompraTotalValor> {
		const response = await this.service.getOrdemCompraTotalValores({
			centroCustos,
			titulo,
			fornecedores,
			dataOrdemCompraDe,
			dataOrdemCompraAte,
			ordemCompras,
			produtosServicos,
			dataPagoDe,
			dataPagoAte,
			subcontas,
			statusOC,
		});
		return response.item;
	}

	async updateAtributosCompras(
		exibirDataCadastro: boolean,
		exibirDataCadastroRequisicao: boolean,
		exibirDataAprovacaoColetaPreco: boolean,
		notaCorte: number,
		observacoes: string,
	): Promise<void> {
		await this.service.updateAtributosCompras({
			exibirDataCadastro,
			exibirDataCadastroRequisicao,
			exibirDataAprovacaoColetaPreco,
			notaCorte,
			observacoes,
		});
	}

	async getAllEntregaProdutoServico(
		idOrdemCompra: number,
		produtosServicos: number[] | null,
		page: number,
		rowsPerPage: number,
	): Promise<Paginated<ProdutoServicoEntregue>> {
		return await this.service.getAllEntregaProdutoServico({
			idOrdemCompra,
			produtosServicos,
			page,
			rowsPerPage,
		});
	}

	async deleteEntregaProdutoServico(
		idOrdemCompra: number,
		idProdutoServicoEntregue: number,
	): Promise<void> {
		await this.service.deleteEntregaProdutoServico({
			idOrdemCompra,
			idProdutoServicoEntregue,
		});
	}

	async getAllOCProdutoServicosParaEntrega(
		idOrdemCompra: number,
	): Promise<ProdutoServicoParaEntrega[]> {
		const response = await this.service.getAllOCProdutoServicosParaEntrega({
			idOrdemCompra,
		});
		return response.itens;
	}

	async deleteColetaProdutoServico(
		idColetaPreco: number,
		idColetaProdutoServico: number,
	): Promise<void> {
		await this.service.deleteColetaProdutoServico({
			idColetaPreco,
			idColetaProdutoServico,
		});
	}

	//#endregion

	async updateStatusRequisicaoCompra(
		idRequisicaoCompra: number,
		status: number,
	): Promise<void> {
		await this.service.updateStatusRequisicaoCompra({
			idRequisicaoCompra,
			status,
		});
	}

	async updateStatusColetaPreco(
		idColetaPreco: number,
		status: number
	): Promise<void> {
		await this.service.updateStatusColetaPreco({
			idColetaPreco,
			status,
		});
	}

	async getDashboardCompras(
	): Promise<DashboardCompras> {
		const response = await this.service.getDashboardCompras({});
		return response.item;
	}

	async downloadRequisicaoCompraArquivo(
		idRequisicaoCompra: number,
		nroArquivo: number,
	): Promise<Blob> {
		const response = await this.service.downloadRequisicaoCompraArquivo({
			idRequisicaoCompra,
			nroArquivo,
		});
		return response;
	}

	async downloadOrdemCompraArquivo(
		idOrdemCompra: number,
	): Promise<Blob> {
		const response = await this.service.downloadOrdemCompraArquivo({
			idOrdemCompra,
		});
		return response;
	}

	async downloadColetaPrecoArquivo(
		idColetaPreco: number,
		nroArquivo: number,
	): Promise<Blob> {
		const response = await this.service.downloadColetaPrecoArquivo({
			idColetaPreco,
			nroArquivo,
		});
		return response;
	}

	async downloadEntregaOrdemCompraArquivo(
		idOrdemCompra: number,
		idProdutoServicoEntregue: number,
	): Promise<Blob> {
		const response = await this.service.downloadEntregaOrdemCompraArquivo({
			idOrdemCompra, idProdutoServicoEntregue
		});
		return response;
	}

	async downloadBoletoAvaliacaoOrdemCompra(
		idOrdemCompra: number,
	): Promise<Blob> {
		return this.service.downloadBoletoAvaliacaoOrdemCompra({ idOrdemCompra });
	}

	async getAllFuncionariosAprovadores(
		nomeEmailFuncionario: string | null,
		centrosCusto: number[] | null,
	): Promise<FuncionarioAprovador[]> {
		const response = await this.service.getAllFuncionariosAprovadores({
			nomeEmailFuncionario,
			centrosCusto,
		});
		return response.itens;
	}

	async createFuncionarioAprovador(
		idFuncionario: number,
		funcionarioEmail: string,
		valorMaximo: number | null,
	): Promise<void> {
		await this.service.createFuncionarioAprovador({
			idFuncionario,
			funcionarioEmail,
			valorMaximo,
		});
	}

	async deleteFuncionarioAprovador(
		idFuncionarioAprovador: number,
	): Promise<void> {
		await this.service.deleteFuncionarioAprovador({ idFuncionarioAprovador });
	}

	async updateFuncionarioAprovador(
		idFuncionarioAprovador: number,
		funcionarioEmail: string,
		valorMaximo: number | null,
	): Promise<void> {
		await this.service.updateFuncionarioAprovador(idFuncionarioAprovador, { funcionarioEmail, valorMaximo });
	}

	async getFuncionarioParaAprovacaoDropDown(
	): Promise<FuncionarioAprovacaoDropDown[]> {
		const response = await this.service.getFuncionarioParaAprovacaoDropDown({});
		return response.itens;
	}

	async getFuncionariosAprovadoresDropDown(
	): Promise<FuncionarioAprovacaoDropDown[]> {
		const response = await this.service.getFuncionariosAprovadoresDropDown({});
		return response.itens;
	}

	async sendAprovacaoColetaPreco(
		idColetaPreco: number,
		subject: string,
		body: string,
	): Promise<void> {
		await this.service.sendAprovacaoColetaPreco({
			idColetaPreco,
			subject,
			body,
		});
	}
}
